import React from "react";
import clsx from "clsx";

import { Box, Hidden, makeStylesSeeded } from "@origin-digital/ods-core";

import { IKrakenNavLink } from "./interfaces";
import { navigationBarHeight } from "./helpers/consts";
import { isActiveNavSection } from "./helpers/NavHelpers";
import { NavLinkContainer } from "./NavLinkContainer";

const useStyles = makeStylesSeeded(({ palette }) => ({
  linkContainer: {
    display: "flex",
    minHeight: navigationBarHeight,
    borderLeft: `1px solid ${palette.grey["200"]}`,
    paddingLeft: 16,
    paddingRight: 16,
    cursor: "pointer",
  },
  navLinkTitle: {
    margin: 0,
    color: palette.grey["400"],
    fontSize: 12,
    lineHeight: "20px",
    fontWeight: 400,
  },
  navLinkTitleUnderline: {
    borderBottom: `2px solid ${palette.warning.main}`,
  },
  iconContainer: {
    display: "flex",
    position: "relative",
    "& svg": {
      fontSize: 20,
    },
    '&& [class*="MuiSvgIcon-root"]': {
      height: 38,
      margin: "0px 6px 0px 0px",
      color: palette.grey["300"],
    },
  },
  iconContainerMobile: {
    "& svg": {
      fontSize: 28,
    },
    '&& [class*="MuiSvgIcon-root"]': {
      margin: 0,
    },
  },
}));

type ICollapsibleNavLink = IKrakenNavLink;

export const CollapsibleNavLink = (props: ICollapsibleNavLink) => {
  const { linkConfig } = props;
  const { name, href, icon, title } = linkConfig;
  const active = isActiveNavSection(href);
  const styles = useStyles();

  return (
    <>
      <Hidden above="sm">
        <Box
          data-id="mobile-collapsible-link"
          className={clsx(styles.linkContainer)}
        >
          <NavLinkContainer href={href} id={`${name}-container`}>
            <Box
              className={clsx(styles.iconContainer, styles.iconContainerMobile)}
            >
              {icon}
            </Box>
          </NavLinkContainer>
        </Box>
      </Hidden>
      <Hidden>
        <Hidden data-id="desktop-collapsible-link" below="md">
          <Box className={clsx(styles.linkContainer)}>
            <NavLinkContainer href={href} id={`${name}-container`}>
              <Box className={clsx(styles.iconContainer)}>{icon}</Box>
              <Box
                className={clsx(
                  styles.navLinkTitle,
                  active && styles.navLinkTitleUnderline
                )}
                data-id={`${name}-title`}
                component="p"
              >
                {title}
              </Box>
            </NavLinkContainer>
          </Box>
        </Hidden>
      </Hidden>
    </>
  );
};
